/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DiscreteNumericListDto } from './DiscreteNumericListDto';
import {
    DiscreteNumericListDtoFromJSON,
    DiscreteNumericListDtoFromJSONTyped,
    DiscreteNumericListDtoToJSON,
} from './DiscreteNumericListDto';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface ElectronBeamQualityDoseRateValueListDto
 */
export interface ElectronBeamQualityDoseRateValueListDto {
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    beamQualityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    radiationType: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    energy: NumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    highDoseTechniqueType: EnumerationValueDto;
    /**
     * 
     * @type {DiscreteNumericListDto}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    selectedDoseRates: DiscreteNumericListDto;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDoseRateValueListDto
     */
    $type?: ElectronBeamQualityDoseRateValueListDtoTypeEnum;
}


/**
 * @export
 */
export const ElectronBeamQualityDoseRateValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersElectronBeamQualityDoseRateValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.ElectronBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ElectronBeamQualityDoseRateValueListDtoTypeEnum = typeof ElectronBeamQualityDoseRateValueListDtoTypeEnum[keyof typeof ElectronBeamQualityDoseRateValueListDtoTypeEnum];


/**
 * Check if a given object implements the ElectronBeamQualityDoseRateValueListDto interface.
 */
export function instanceOfElectronBeamQualityDoseRateValueListDto(value?: unknown): value is ElectronBeamQualityDoseRateValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ElectronBeamQualityDoseRateValueListDtoTypeEnum)[0];
}

export function ElectronBeamQualityDoseRateValueListDtoFromJSON(json: any): ElectronBeamQualityDoseRateValueListDto {
    return ElectronBeamQualityDoseRateValueListDtoFromJSONTyped(json, false);
}

export function ElectronBeamQualityDoseRateValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectronBeamQualityDoseRateValueListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'beamQualityId': !exists(json, 'beamQualityId') ? undefined : json['beamQualityId'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'radiationType': EnumerationValueDtoFromJSON(json['radiationType']),
        'energy': NumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': EnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        'selectedDoseRates': DiscreteNumericListDtoFromJSON(json['selectedDoseRates']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ElectronBeamQualityDoseRateValueListDtoToJSON(value?: ElectronBeamQualityDoseRateValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'iuid': value.iuid,
        'beamQualityId': value.beamQualityId,
        'isEnabled': value.isEnabled,
        'radiationType': EnumerationValueDtoToJSON(value.radiationType),
        'energy': NumericValueDtoToJSON(value.energy),
        'highDoseTechniqueType': EnumerationValueDtoToJSON(value.highDoseTechniqueType),
        'selectedDoseRates': DiscreteNumericListDtoToJSON(value.selectedDoseRates),
        '$type': value.$type,
    });
}

